import H from 'history'
import queryString from 'query-string'
import {
    BreachEvent,
    BreachCompleteEventPublicationInfo,
} from '@news-mono/web-common'
import {
    click_origin_breach_screen,
    SSWQueryString,
    click_origin_breach_screen_inline,
} from '@news-mono/web-common'
import { DataLayerEventName } from '@news-mono/web-common'
import { showSportBreach } from './helpers'
import { click_origin_registration_wall } from '@news-mono/web-common'

export function createIsEntitledChangeHandler(
    creativeName: string,
    deal: string,
    location: H.Location,
    onEvent: (event: BreachEvent) => void,
    isLoggedIn?: boolean,
    sportBreachEnabled = false,
): (event: { entitled: boolean; loggedInStatusChecked: boolean }) => void {
    return ({ entitled, loggedInStatusChecked }) => {
        if (!loggedInStatusChecked) {
            return
        }

        const eventPayload: BreachEvent['payload'] = {
            paywallType: 'freemium',
            leadDepth: 0,
            creative: creativeName,
            breachScreenType: 'Premium - Inline',
            popupMethod: 'auto',
            deal,
            pricepoint: [7, 8],
        }

        /**
         * Specific to breach complete events only
         *
         * Due to the nature of breachscreen.complete events being fired after a few starts align
         * there is a change a page nav can happen in the mean time, and due to GA's reliance of
         * document.title this can be the new page title, we want to ensure that by the time the
         * breachscreen.complete event is fired its got a copy of the document.title at the time.
         * For integrity & consistency.
         */
        const breachCompleteEventPageInfo: BreachCompleteEventPublicationInfo = {
            currentPageTitle: document.title,
        }

        /**
         * Free articles are entitled to view, but they also show an inline
         * subscription breach if you are not logged in and inside the sport
         * section.
         */
        if (
            entitled &&
            !isLoggedIn &&
            showSportBreach(location, sportBreachEnabled)
        ) {
            onEvent({
                type: DataLayerEventName.breachScreenAvailable,
                originator: 'breachscreen',
                payload: {
                    ...eventPayload,
                    popupMethod: 'auto',
                    // Hardcoded to The West's inline promos, which are inserted after the 6th paragraph
                    leadDepth: 7,
                    breachScreenType: 'Premium - Inline - Promo',
                },
            })
        } else if (entitled) {
            const query = queryString.parse(location.search)

            // Fire a regwall event DPT-2464
            if (query.clickOrigin === click_origin_registration_wall) {
                onEvent({
                    type: DataLayerEventName.breachScreenComplete,
                    originator: 'breachscreen',
                    payload: {
                        paywallType: 'freemium',
                        leadDepth: 3, // hardcoded for now
                        creative: 'registration wall - launch',
                        breachScreenType: 'Registration - Inline',
                        popupMethod: 'auto',
                        deal: '',
                        pricepoint: [],
                        ...breachCompleteEventPageInfo,
                    },
                })
                return
            }

            // Need to ensure we convert the necessary items to numbers for the logic check below
            const sswQueryString: SSWQueryString = {
                transactionId: Number(query.transactionId),
                transactionTotal: Number(query.transactionTotal),
                transactionTax: Number(query.transactionTax),
                productSku: query.productSku,
                productName: query.productName,
                clickOrigin: query.clickOrigin,
            }

            const { clickOrigin, ...sswTransaction } = sswQueryString
            // Only raise when click origin is breach or breach inline
            if (
                sswTransaction.transactionId &&
                clickOrigin === click_origin_breach_screen
            ) {
                onEvent({
                    type: DataLayerEventName.breachScreenComplete,
                    originator: 'breachscreen',
                    payload: {
                        ...eventPayload,
                        ...breachCompleteEventPageInfo,
                        ...sswTransaction,
                        breachScreenType: 'Premium - Inline',
                    },
                })
            } else if (
                sswTransaction.transactionId &&
                clickOrigin === click_origin_breach_screen_inline
            ) {
                onEvent({
                    type: DataLayerEventName.breachScreenComplete,
                    originator: 'breachscreen.inline',
                    payload: {
                        ...eventPayload,
                        ...breachCompleteEventPageInfo,
                        ...sswTransaction,
                        popupMethod: 'auto',
                        // Hardcoded to The West's inline promos, which are inserted after the 6th paragraph
                        leadDepth: 7,
                        breachScreenType: 'Premium - Inline - Promo',
                    },
                })
            }
        } else {
            onEvent({
                type: DataLayerEventName.breachScreenAvailable,
                originator: 'breachscreen',
                payload: eventPayload,
            })
        }
    }
}
